<template>
  <button
    @click="
      () => typeof loadMoreData == 'function' && loadMoreData()
    "
    :aria-label="$t('general.load_mode')"
    :title="$t('general.load_mode')"
    :class="
      `${
        isLoadingMore ? 'disabled' : ''
      } flex items-center justify-center gap-2 !outline-none overflow-hidden bg-[#0963FF] hover:bg-[#0963FF]/90 min-w-[110px] sm:min-w-[125px] md:min-w-[150px] text-[#fff] font-bold text-sm lg:text-[0.928rem] md:text-[0.938rem] 3xl:text-base px-5 sm:px-8 py-1.5 sm:py-2 rounded-[19px]`.trim()
    "
    :disabled="isLoadingMore"
  >
    <span>{{ $t("general.more") }}</span>
    <span
      v-if="isLoadingMore"
      className="loader flex items-center justify-center rounded-md"
    >
      <span
        className=" w-6 aspect-square rounded-full border-4 border-[#d0cfcf] border-t-[#ffff] animate-spin "
      ></span>
    </span>
  </button>
</template>

<script>
export default {
    props: {
        isLoadingMore: {
            type: Boolean,
            default: false,
            required: true
        },
        loadMoreData: {
            type: Function,
            required: true
        }
    }
};
</script>

<style></style>
